import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[mapOption]',
})
export class MapOptionDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}

